import "./index.css";
import "viem/window";

import App from "App";
import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <App />,
  // </StrictMode>,
);
